<template>
    <div>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="set-value-modal-label">Set Nilai {{ getTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="text-center" v-if="loading">Mohon tunggu</div>
                    <template v-else>
                        <div v-for="(item, key) in items" :key="key">
                            <label class="label label-primary">{{ key+1 }}</label>
                            <br/>
                            <div class="row">
                                <div class="form-group col-md-4 mb-0">
                                    <label>Rumus Kriteria Nilai</label>
                                    <input type="text" :name="`result_parameter[${key}]`" class="form-control" v-model="item.result_parameter" placeholder="eg: [V]<10" />
                                    <span class="form-text text-muted">[V] : Sebagai Variabel Hasil sebagai rumus</span>
                                </div>
                                <div class="form-group col-md-4 mb-0">
                                    <label>Deskripsi Kriteria Nilai</label>
                                    <input type="text" :name="`result_parameter_label[${key}]`" class="form-control" v-model="item.result_parameter_label" placeholder="eg: Deskripsi" />
                                </div>
                                <div class="form-group col-md-3 mb-0">
                                    <label>Nilai *</label>
                                    <input type="text" :name="`result_name[${key}]`" class="form-control" v-model="item.result_name" placeholder="eg: 2.00" />
                                </div>
                                <div class="form-group col-md-1 mb-0 mt-8">
                                    <button @click="remove(key)" type="button" class="btn btn-light-danger btn-sm btn-icon"><i class="la la-times"></i></button>
                                </div>
                            </div>
                            <hr />
                        </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <div class="col-md-12 d-flex">
                        <div class="flex-row-fluid flex-column align-items-start">
                            <button type="button" class="btn btn-info" @click="addNew"><i class="la la-plus"></i>&nbsp;Tambah Penilaian</button>
                        </div>
                        <div class="flex-column justify-content-end">
                            <div v-if="saveLoading" class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <button type="button" class="btn btn-primary" @click="save" :disabled="saveLoading"><i class="la la-save"></i>&nbsp;Simpan Data</button>
                            <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal">Tutup</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'TemplateReportBluSetValueForm',
        props: {
            token: String,
            data: {
                type: Object,
                default: () => (null)
            }
        },
        data() {
            return {
                items: [],
                loading: true,
                saveLoading: false,
            }
        },
        watch: {
            data(val) {
                this.loading = true
                this.initValue()
                setTimeout(() => {
                    this.loading = false
                }, 1500)
            },
        },
        computed: {
            getTitle() {
                if (!this.data) return ''
                return this.data.indicator ? this.data.indicator.name : ''
            }
        },
        methods: {
            initValue() {
                if (this.data.criteria_value_data) {
                    this.items = this.data.criteria_value_data
                } else {
                    this.addNew()
                }
            },
            addNew() {
                this.items.push({
                    result_name: null,
                    result_parameter: null,
                    result_parameter_label: null
                })
            },
            remove(key) {
                this.items.splice(key, 1)
            },
            setErrorMessage(message = '', key = '') {
                swal.fire(
                    'Formulir belum lengkap',
                    `Mohon lengkapi formulir ${message} pada baris ${key}`,
                    'error'
                )
            },
            save() {
                this.items.map((item, key) => {
                    if (!item.result_name) {
                        this.setErrorMessage(`Nilai`, key+1)
                        return false
                    }
                })
                this.saveLoading = true
                const params = {
                    _token: this.token,
                    items: this.items,
                }
                axios.patch(`/master-data/report-blu/${this.data.id}`, params).then(({data}) => {
                    this.saveLoading = false
                    swal.fire(
                        'Sukses!',
                        data.message,
                        'success'
                    ).then(() => {
                        window.location = ''
                    })
                }).catch((err) => {
                    this.saveLoading = false
                    const { data } = err.response
                    swal.fire(
                        'Opps!',
                        data.message,
                        'error'
                    )
                })
            },
            close() {
                this.items = []
            }
        }
    }
</script>
